import { render, staticRenderFns } from "./DashboardProdutor.vue?vue&type=template&id=0a1e109c"
import script from "./DashboardProdutor.vue?vue&type=script&lang=js"
export * from "./DashboardProdutor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports